module.exports = __webpack_public_path__ + "static/media/twitter.643ef8c4.png";